import Images from '../../../state/stores/Image/images';
import SecondaryButton from '../../Button/SecondaryButton';
import { COLORS } from '../../../config/designSystem/Colors';
import { ParagraphMRegular } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { Image, StyleSheet, View } from 'react-native';

interface NoFaceScanCardProps {
  message: string;
  buttonLabel: string;
  onPress: () => void;
}

export const NoFaceScanCard = ({ message, buttonLabel, onPress }: NoFaceScanCardProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <View style={styles.cardContent}>
          <Image
            source={Images['logo']['multicolor']}
            style={styles.logo}
            resizeMode="contain"
          />
          <ParagraphMRegular color={COLORS.content.primary} style={styles.text}>
            {message}
          </ParagraphMRegular>
        </View>
        <View style={styles.buttonContainer}>
          <SecondaryButton
            onPress={onPress}
            label={buttonLabel}
            marginHorizontal={0}
            paddingHorizontal={16}
            paddingVertical={8}
            height={40}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: SPACING['sp-16'],
    paddingVertical: SPACING['sp-24'],
  },
  card: {
    backgroundColor: COLORS.brand[50],
    borderRadius: 12,
    padding: 22,
    maxWidth: 400,
    width: '100%',
  },
  cardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  logo: {
    width: 48,
    height: 48,
    borderRadius: 12,
  },
  text: {
    flex: 1,
  },
  buttonContainer: {
    alignItems: 'center',
    width: '100%',
    marginTop: SPACING['sp-16'],
  },
});
